/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UnlinkEMARequestBody = {
  /**
   * Optimistic binding generation.
   */
  expectedGeneration: number;
  remoteSessionIssuerId: string;
  /**
   * Canonical intended resource URI.
   */
  resource: string;
  userSessionIssuerId: string;
};

/** @internal */
export type UnlinkEMARequestBody$Outbound = {
  expected_generation: number;
  remote_session_issuer_id: string;
  resource: string;
  user_session_issuer_id: string;
};

/** @internal */
export const UnlinkEMARequestBody$outboundSchema: z.ZodMiniType<
  UnlinkEMARequestBody$Outbound,
  UnlinkEMARequestBody
> = z.pipe(
  z.object({
    expectedGeneration: z.int(),
    remoteSessionIssuerId: z.string(),
    resource: z.string(),
    userSessionIssuerId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      expectedGeneration: "expected_generation",
      remoteSessionIssuerId: "remote_session_issuer_id",
      userSessionIssuerId: "user_session_issuer_id",
    });
  }),
);

export function unlinkEMARequestBodyToJSON(
  unlinkEMARequestBody: UnlinkEMARequestBody,
): string {
  return JSON.stringify(
    UnlinkEMARequestBody$outboundSchema.parse(unlinkEMARequestBody),
  );
}
